import { Link, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const BackLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  cursor: 'pointer',
  textDecoration: 'none',
});

export const LinkText = styled(Typography)<{ color: string }>(({ color }) => {
  return {
    color: color || palette.text.header_accent,
    fontSize: '1rem',
    fontWeight: '600',
    lineHeight: '22px',
  };
});
